import React from 'react';
import {
  useController,
  useFormContext,
} from '@grnhse/seedling/lib/birch/components/forms/form';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import RadioGroup from '@grnhse/seedling/lib/birch/components/radio_group';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';
import BookmarkIcon from 'shared/components/birch/icons/bookmark';
import BookmarkFilledIcon from 'shared/components/birch/icons/bookmark_filled';
import PopoverButton from 'talent_matching/components/filters/popover_button';
import styled from 'styled-components';

const t = withLocalePrefix('talent_matching.filter_row.saved_for_later');

const ClearButton = styled(TertiaryButton)`
  margin-left: -6px;
`;

const SavedForLaterRadioValue = {
  All: 'all',
  Saved: 'saved',
  NotSaved: 'not_saved',
} as const;
type SavedForLaterRadioValue =
  typeof SavedForLaterRadioValue[keyof typeof SavedForLaterRadioValue];

const SavedForLaterContent = () => {
  const { field } = useController({ name: 'savedForLater' });

  const radioValue: SavedForLaterRadioValue =
    field.value ?? SavedForLaterRadioValue.All;

  const handleChange = (value?: string | number) => {
    field.onChange(
      value === SavedForLaterRadioValue.All || value === undefined
        ? null
        : value
    );
  };

  const handleClear = () => {
    field.onChange(null);
  };

  return (
    <Stack spacing={2} direction="column">
      <RadioGroup
        name={field.name}
        ariaLabel={t('description')}
        options={[
          { label: t('radio_all'), value: SavedForLaterRadioValue.All },
          { label: t('radio_saved'), value: SavedForLaterRadioValue.Saved },
          {
            label: t('radio_not_saved'),
            value: SavedForLaterRadioValue.NotSaved,
          },
        ]}
        value={radioValue}
        onChange={handleChange}
      />
      <ClearButton onClick={handleClear} size="md">
        {t('clear')}
      </ClearButton>
    </Stack>
  );
};

const SavedForLater = () => {
  const { watch } = useFormContext();
  const savedForLater = watch('savedForLater');
  const icon = savedForLater === 'saved' ? BookmarkFilledIcon : BookmarkIcon;

  return (
    <PopoverButton buttonLabel={t('title')} title={t('title')} icon={icon}>
      <SavedForLaterContent />
    </PopoverButton>
  );
};

export default SavedForLater;
